module.exports = __webpack_public_path__ + "img/gd1.f2b9582d.jpg";